// uses 'on' method as some cards are dynamically created e.g. slick slides and recommended items
$(document).on('click', '.quickadd-variant', function() {  
  let variant_val = $(this).val();
  let quickadd_form = $(this).attr("form");
  
  $('.quickadd-final-' + quickadd_form).val(variant_val);
  $('.quickadd-submit-' + quickadd_form).click();
});

$(document).on('click', '.quickadd-open', function() {
  $(this).toggleClass('active');
});

$(document).on('click', '.quickadd-option-header', function() {
  $(this).closest('.card__quickadd-wrapper').find('.quickadd-option').removeClass('active');
  $(this).closest('.quickadd-option').addClass('active');
});